var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { beanFullNameFromOnionName, cast, UseScope } from 'zova';
import { Bean } from 'zova-module-a-bean';
import { BeanModelBase } from 'zova-module-a-model';
export let BeanTheme = (_dec = Bean(), _dec2 = __z_BeanInfo({
  module: "a-style"
}), _dec3 = UseScope("a-ssr"), _dec4 = Reflect.metadata("design:type", typeof ScopeModuleASsr === "undefined" ? Object : ScopeModuleASsr), _dec(_class = _dec2(_class = (_class2 = class BeanTheme extends BeanModelBase {
  constructor(...args) {
    super(...args);
    this.name = void 0;
    this.darkMode = void 0;
    // auto/true/false
    this._dark = void 0;
    this.token = void 0;
    this._mediaDark = void 0;
    this._onMediaDarkChange = void 0;
    _initializerDefineProperty(this, "$$scopeSsr", _descriptor, this);
  }
  get dark() {
    return this._dark;
  }
  async __init__() {
    const cookieTheme = this.sys.config.ssr.cookie;
    const cookieThemeDarkDefault = this.$$scopeSsr.config.cookieThemeDarkDefault;
    // support admin
    this.name = this.$useState(cookieTheme ? 'cookie' : 'local', {
      queryKey: ['themename'],
      meta: {
        persister: {
          maxAge: this.scope.config.model.themename.persister.maxAge
        },
        defaultData: this.scope.config.defaultTheme
      }
    });
    this.darkMode = this.$useState(cookieTheme ? 'cookie' : 'local', {
      queryKey: ['themedark'],
      meta: {
        persister: {
          maxAge: this.scope.config.model.themename.persister.maxAge,
          deserialize: (value, deserializeDefault) => {
            if (cookieTheme && value === 'auto') value = cookieThemeDarkDefault;
            return deserializeDefault(value);
          }
        },
        defaultData: cookieTheme ? cookieThemeDarkDefault : 'auto'
      }
    });
    this._updateDark();
    this.$watch(() => this.darkMode, () => {
      this._updateDark();
    });
    if (process.env.CLIENT) {
      this.$watch([() => this.name, () => this._dark], () => {
        this._applyTheme();
      });
    }

    // not use watch.immediate for await done
    await this._applyInitialThemeAndSsrDualOutput();
  }
  __dispose__() {
    this._listenMediaDarkChange(false);
  }
  _updateDark() {
    this._dark = this._getDarkFromDarkMode(this.darkMode);
  }
  async _applyInitialThemeAndSsrDualOutput() {
    // When server-side theme cookies are disabled, apply twice during SSR initialization so the
    // server emits both data-ssr-theme-dark-false/true markers and the browser can resolve the
    // final data-theme during bootstrap.
    await this._applyTheme();
    if (this.sys.config.ssr.cookieDisabledOnServer) {
      this.toggleDark();
      await this._applyTheme();
    }
  }
  async _applyTheme() {
    const name = this.name;
    const dark = this._dark;
    const theme = await this._loadThemeBean(name);
    if (!theme) {
      this.name = this.scope.config.defaultTheme;
      await this._applyTheme();
      return;
    }
    const res = await theme.apply({
      name,
      dark
    });
    this.token = cast(res).token;
    const handler = res.handler ?? this.scope.config.defaultThemeHandler;
    if (handler) {
      const themeHandler = await this.bean._getBean(beanFullNameFromOnionName(handler, 'meta'), true);
      await themeHandler.apply({
        name,
        dark,
        token: this.token
      });
    }
  }
  async _loadThemeBean(name) {
    const parts = name.split(':');
    if (parts.length === 1) {
      throw new Error(`invalid theme name: ${name}`);
    }
    const moduleName = parts[0];
    if (!this.app.meta.module.exists(moduleName)) return;
    return await this.bean._getBean(beanFullNameFromOnionName(name, 'theme'), true);
  }
  toggleDark() {
    this.darkMode = !this._dark;
    this._updateDark(); // immediate
  }
  _getDarkFromDarkMode(mode) {
    if (mode === undefined) mode = 'auto';
    if (mode === 'auto') {
      this._listenMediaDarkChange(true);
      return !!this._mediaDark?.matches;
    } else {
      this._listenMediaDarkChange(false);
      return mode;
    }
  }
  _listenMediaDarkChange(listen) {
    if (process.env.SERVER) return;
    if (listen) {
      if (!this._mediaDark) {
        this._mediaDark = window.matchMedia('(prefers-color-scheme: dark)');
        this._onMediaDarkChange = async () => {
          this._updateDark();
          this._applyTheme();
        };
        this._mediaDark.addEventListener('change', this._onMediaDarkChange);
      }
    } else {
      if (this._mediaDark) {
        this._mediaDark.removeEventListener('change', this._onMediaDarkChange);
        this._onMediaDarkChange = undefined;
        this._mediaDark = undefined;
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "$$scopeSsr", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class) || _class);